import React from 'react'
import { Link } from 'react-router'

import LanguageSwitcher from './LanguageSwitcher'

import styles from './styles/app.scss'

import logo from './../assets/images/wopi-logo.svg'

export default class App extends React.Component {
  render() {
    const hideNonAdminLanguages =
      this.props.hideNonAdminLanguages === undefined ? true : this.props.hideNonAdminLanguages

    return (
      <div>
        <div className={styles.topBar} />

        <div className={styles.app}>
          <nav>
            <Link to="/">
              <img src={logo} className={styles.logo} />
            </Link>

            {!this.props.hideLanguageSwitcher && (
              <div className={styles.languageSwitcherContainer}>
                <LanguageSwitcher
                  onChangeLanguage={this.props.onChangeLanguage}
                  currentLanguage={this.props.currentLanguage}
                  hideNonAdminLanguages={hideNonAdminLanguages}
                />
              </div>
            )}
          </nav>

          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js